import React, { useEffect, type FC } from 'react';
import { Redirect as ReactRouterRedirect, type RedirectProps } from 'react-router-dom';

import { useNavigation } from '../navigation';
import useWizardEmitNavigateEvent from '../hooks/use-wizard-emit-navigate-event';
import useGetEmbeddedLocation from '../hooks/use-get-embedded-location';
import getRelativeUrlStringFromLocation from '../utils/get-relative-url-string-from-location';

const EmbeddedRedirect: FC<RedirectProps> = ({ to, ...props }) => {
  const emitNavigateEvent = useWizardEmitNavigateEvent();
  const getEmbeddedLocation = useGetEmbeddedLocation();
  const embeddedLocation = getEmbeddedLocation(to);

  useEffect(() => {
    const relativeUrl = getRelativeUrlStringFromLocation(to);
    emitNavigateEvent(relativeUrl);
  }, []);

  if (!embeddedLocation) {
    return null;
  }

  return <ReactRouterRedirect to={embeddedLocation} {...props} />;
};

const Redirect: FC<RedirectProps> = (props) => {
  const { isEmbedded } = useNavigation();
  const RedirectComponent = isEmbedded ? EmbeddedRedirect : ReactRouterRedirect;

  return <RedirectComponent {...props} />;
};

export default Redirect;
